export default __webpack_public_path__ + "static/media/dresses1.6600eafd.jpg";